import { render, staticRenderFns } from "./ContractorCategories.vue?vue&type=template&id=bc5f25b8&scoped=true&"
import script from "./ContractorCategories.vue?vue&type=script&lang=js&"
export * from "./ContractorCategories.vue?vue&type=script&lang=js&"
import style0 from "./ContractorCategories.vue?vue&type=style&index=0&id=bc5f25b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5f25b8",
  null
  
)

export default component.exports